import React from 'react'
import { Edit } from 'react-admin'
import NoDeleteButtonToolbar from 'ui-shared/CustomToolbars/NoDeleteButtonToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import ServicesConfigForm from './ServicesConfigForm'

const ServicesConfigEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit id="servicesconfig">
        <ServicesConfigForm toolbar={<NoDeleteButtonToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default ServicesConfigEdit
